import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

export const useQueryRiskDrivers = (params: QueryParams, endpoint) => {
    return useQuery<Response, QueryError, Response, [QueryKeys, unknown]>({
        queryKey: ['riskDrivers', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.runQsra) && Boolean(params.taskVersionHashCode) && Boolean(params.metaDataId),
    });
};

interface QueryParams {
    metaDataId: number;
    numOfIterations: number;
    riskIds: number[];
    taskVersionHashCode: string;
    runQsra: boolean;
}

interface Response {
    tornadoResponse: {
        impactType: string;
        targetActivityId: string;
        targetActivityName: string;
        tornadoRisks: {
            riskId: string;
            riskName: string;
            impactValue: number;
            riskUid: number;
        }[];
    }[];
}
